export default {
  home: "Accueil",
  whoWeare: "Qui sommes-nous",
  OurEvents: "Nos événements",
  Media: "Media",
  ContactUs: "Contactez-nous",
  Domaines: "Domaines d'intervention",
  Realisations: "Réalisations",
  OurBlog: "Notre Blog",
  AboutUs: "A propos de nous",
  DonateNow: "Faire un don",
  QuickLink: "Accès rapide",
  LastEvents: "Dérniers événements",
  SeeAllEvent: "Voir tout",
  ReadMore: "Lire plus",
  DownloadReport: "Télécharger le rapport",
  Posts: "Publications",
  OtherDomains: "Autres domaines d'intervention",
  RecentPosts: "Publications recentes",
  AboutMessage:
    "La protection de la propriété privée encourage les entreprises à se développer. Ils font des profits en répondant aux besoins des autres, et parce que ces bénéfices sont conservés par l'entreprise, plutôt que confisqués par les autorités, ils peuvent être investis créant encore plus de richesse à l'avenir.",
  ParticipacifFinance: "Financement participatif",
  MeilleurFacon:
    "La meilleure façon de faire une différence dans la vie des autres",
  LastEventDesc:
    "Restez informé des dernières nouveautés ! Découvrez nos récents événements et ne manquez aucune occasion",
  ExpertBenevole: "Nos experts bénévoles",
  ExpertBenevoleDesc:
    "Découvrez nos experts bénévoles, passionnés et engagés pour faire la différence.",
  LastNews: "Nos dernières nouvelles & Articles",
  LastNewsDesc:
    "Découvrez nos dernières publications et ne manquez aucune nouvelle importante.",
  WhatWeDo: "Ce que nous faisons",
  WhatWeDoTitle: "Nous agissons <br/> pour un monde meilleur",
  WhatWeDoDesc:
    "À travers nos initiatives, nous apportons aide et espoir aux <br/> communautés dans le besoin. Découvrez comment <br/> nous faisons la différence chaque jour.",
  OurTeam: "Notre équipe",
  OurPartners: "Nos partenaires",
  OurPhotos: "Nos photos",
  OurVideos: "Nos vidéos",
  NothingToDisplay: "Nothing to display",
  OurMission: "Notre mission",
  OurVision: "Notre vision",
  SearchTitle: "Trouvez exactement ce que vous cherchez.",
  SimilarPost: "Posts similaires",
  Categories: "Catégories",
  PageNotFound: "Page not found",
  MainOffice: "Bureau principal",
  EmailAddress: "Adresse email",
  PhoneNumber: "Numéro de téléphone",
  "Let Us Help You": "Laissez-nous vous aider",
  FooterNews:
    "Abonnez-vous à notre newsletter pour recevoir nos dernières mises à jour et actualités",
  OurPartnersDesc:
    "Nos partenaires sont essentiels à notre mission de favoriser la collaboration et de générer un changement positif. Ensemble, nous œuvrons pour renforcer notre communauté, partager nos connaissances et créer un impact durable grâce à un soutien mutuel et des valeurs communes.",
  AboutTitle: "Derrière chaque réussite se cache une histoire.",
  historique: "Historique",
  OurActivities: "Nos activités",
  OurProjects: "Nos projets",
  News: "Nos actualités",
  Reports: "Nos rapports",
  MeetOurTeam: "Une équipe. Une mission. Un impact.",
  OurObjectifs: "Nos objectifs",
  UpComingEvents: "Événements à venir",
  ContactSection: "Contact avec NSCICO",
  ContactSectionDesc: "Vous avez juste une petite question ?",
  YourName: "Votre nom",
  YourEmail: "Votre adresse email",
  YourMessage: "Votre message",
  Subject: "Objet",
  YourPhone: "Votre numéro de téléphone",
  FieldRequired: "Ce champ est requis",
  InvalidEmail: "Cette adresse email est invalide",
  Welcome:"Bienvenue à NSCICO"
} as const;
